module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAAAXNSR0IArs4c6QAAAE9JREFUKFONkEkOgDAMA8c/hzN9LpyNEohUlVbCt2hiZ5HtDTgkXXSS7RNoIwxgILqbpHCnClS9l3ME6Uz4RvVzn9i/YBn1GT5dd3ng9CU3BhlFFw80mtMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/arrow-right-s-fill (1).png
// module id = nRly
// module chunks = 9